/**
 * String Utils
 */
/* tslint:disable:max-line-length */

import { each, trim } from 'lodash';
import * as removeAccents from 'remove-accents';

export function validateEmail(value) {
  return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
}
export function validatePassword(value) {
  return value.length >= 8 && /[A-Z]+/.test(value) && /[0-9]+/.test(value);
}
export function validateString(value) {
  return value && trim(value).length > 2;
}
export function validatePostalCode(value, regex) {
  const reg = new RegExp(`^${regex}$`);
  return reg.test(value);
}

export function toInnerHTML(text: string) {
  return { __html: text };
}
export function stripHTMLTagsFromString(text: string) {
  const stripTagsRegex = /(<([^>]+)>)/ig;
  return text.replace(stripTagsRegex, '');
}

export function sanitizeString(text: string) {
  return removeAccents(text.trim().toLowerCase());
}

export function capitalizeString(text: string) {
  return text.replace(/(^|\s)[a-z]/g, (f) => f.toUpperCase());
}

export function fuzzyFilter(input, search) {
  let inputIndex = 0;
  each(search, (letter, index) => {
    if (letter === input[inputIndex]) {
      inputIndex += 1;
    }
  });

  return inputIndex === input.length;
}

export function twitterHandleFromURL(url: string) {
  const res = url.match(/((https?:\/\/)?(www\.)?twitter\.com\/)?(@|#!\/)?([A-Za-z0-9_]{1,15})(\/([-a-z]{1,20}))?/);
  return res && res.length >= 6 ? res[5] : undefined;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/string.ts